<div class="min-h-screen bg-slate-50 p-4 sm:p-8">
  <div class="max-w-7xl mx-auto mb-6 flex items-center justify-between">
    <div>
      <h1 class="text-2xl font-bold text-slate-800 flex items-center gap-2">
        <span class="p-2 bg-blue-600 rounded-lg text-white">
          <i class="pi pi-database text-lg"></i>
        </span>
        Master Data Management
      </h1>
      <p class="text-sm text-slate-500 mt-1">
        Centralized configuration hub
      </p>
    </div>
  </div>

  <div class="max-w-7xl mx-auto">
    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">

      <ng-container *ngFor="let item of menuItems">

        <div *ngIf="isAccess(item)"
             (click)="navigateToPage(item.url)"
             class="group bg-white rounded-xl border border-slate-200 
                    hover:border-blue-400 hover:shadow-md 
                    transition-all duration-200 cursor-pointer 
                    overflow-hidden flex flex-col">

          <div class="p-4 flex items-start gap-4">

            <!-- ✅ ICON (FIXED) -->
            <div class="flex-shrink-0 w-10 h-10 
                        bg-slate-50 group-hover:bg-blue-50 
                        text-slate-500 group-hover:text-blue-600 
                        rounded-lg flex items-center justify-center 
                        transition-colors border border-slate-100">

              <i
                [ngClass]="getValidIcon(item.icon) + ' text-lg'">
              </i>

            </div>

            <!-- CONTENT -->
            <div class="flex-1 min-w-0">

              <div class="flex items-center justify-between mb-1">
                <h3 class="text-sm font-semibold text-slate-800 truncate group-hover:text-blue-600">
                  {{ item.name }}
                </h3>

                <i class="pi pi-chevron-right text-[10px] text-slate-300 group-hover:translate-x-1 transition-transform"></i>
              </div>

              <div class="flex items-center gap-1.5 mb-3">
                <span class="text-[10px] font-mono px-1.5 py-0.5 bg-slate-100 text-slate-500 rounded">
                  {{ item.code }}
                </span>
              </div>

              <!-- PRIVILEGES -->
              <div class="flex flex-wrap gap-1">
                <span 
                  *ngFor="let privilege of getActivePrivileges(item.privileges).slice(0, 5)"
                  class="text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded-sm"
                  [ngClass]="{
                    'bg-emerald-50 text-emerald-600': privilege.name === 'View',
                    'bg-blue-50 text-blue-600': privilege.name === 'Add',
                    'bg-amber-50 text-amber-600': privilege.name === 'Edit',
                    'bg-rose-50 text-rose-600': privilege.name === 'Delete',
                    'bg-slate-50 text-slate-500': !['View', 'Add', 'Edit', 'Delete'].includes(privilege.name)
                  }"
                >
                  {{ privilege.name }}
                </span>

                <span 
                  *ngIf="getActivePrivileges(item.privileges).length > 5"
                  class="text-[9px] font-bold bg-slate-100 text-slate-400 px-1.5 py-0.5 rounded-sm"
                >
                  +{{ getActivePrivileges(item.privileges).length - 5 }}
                </span>
              </div>

            </div>
          </div>

          <div class="mt-auto h-0.5 w-full bg-transparent group-hover:bg-blue-500 transition-colors"></div>
        </div>

      </ng-container>

    </div>

    <!-- EMPTY STATE -->
    <div *ngIf="menuItems.length === 0"
         class="flex flex-col items-center justify-center py-20 border-2 border-dashed border-slate-200 rounded-2xl">
      <i class="pi pi-folder-open text-4xl text-slate-300 mb-3"></i>
      <h3 class="text-slate-600 font-medium">No records available</h3>
    </div>

  </div>
</div>